 import { Helmet } from "react-helmet";
export default function WebApplicationDevelopmentPage() {
  return (
    <div className="bg-[#0a0d1f] text-white overflow-hidden">

     

<Helmet>
  <title>
    Web Application Development Company in India | Custom Web Apps | SoftCoders
  </title>

  <meta
    name="description"
    content="SoftCoders is a leading web application development company in India building scalable custom web apps, business portals, SaaS platforms, dashboards, ERP systems, CRM software, and enterprise web solutions."
  />

  <meta
    name="keywords"
    content="
    web application development,
    custom web application development,
    web app development company,
    web development company india,
    SaaS web application development,
    enterprise web applications,
    custom business web apps,
    ERP web application,
    CRM web application,
    dashboard development,
    scalable web applications,
    startup web app development,
    cloud web applications,
    responsive web applications,
    AI web applications,
    web portal development,
    business automation web apps,
    modern web applications,
    SoftCoders web development,
    custom software company india
    "
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="SoftCoders" />
  <meta name="language" content="English" />

  {/* Canonical */}
  <link
    rel="canonical"
    href="https://softcoders.in/web-app-development"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Custom Web Application Development Company | SoftCoders"
  />

  <meta
    property="og:description"
    content="Build scalable and high-performance web applications with SoftCoders. Custom SaaS platforms, ERP systems, dashboards, portals, and enterprise web apps."
  />

  <meta
    property="og:url"
    content="https://softcoders.in/web-app-development"
  />

  <meta property="og:type" content="website" />

  <meta
    property="og:image"
    content="https://softcoders.in/og-image.jpg"
  />

  {/* Twitter SEO */}
  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content="Web Application Development Company | SoftCoders"
  />

  <meta
    name="twitter:description"
    content="SoftCoders develops modern custom web applications, SaaS platforms, ERP systems, CRM software, and business automation solutions."
  />

  <meta
    name="twitter:image"
    content="https://softcoders.in/og-image.jpg"
  />

  {/* GEO SEO */}
  <meta name="geo.region" content="IN-HR" />
  <meta name="geo.placename" content="Sirsa, Haryana" />

  {/* Mobile SEO */}
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1"
  />

  {/* Theme */}
  <meta name="theme-color" content="#0a0d1f" />

  {/* Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "SoftwareCompany",
        "name": "SoftCoders",
        "url": "https://softcoders.in",
        "description": "SoftCoders provides custom web application development services including SaaS platforms, ERP systems, CRM software, dashboards, and enterprise web solutions.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Sirsa",
          "addressRegion": "Haryana",
          "addressCountry": "India"
        },
        "serviceType": [
          "Web Application Development",
          "Custom Web Applications",
          "SaaS Development",
          "ERP Web Applications",
          "CRM Web Applications",
          "Enterprise Software Solutions"
        ]
      }
    `}
  </script>
</Helmet>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center px-6 lg:px-20 border-b border-[#4a5fd4]/25">
        <div className="absolute inset-0 bg-gradient-to-br from-[#2d3fb5]/25 via-transparent to-[#6b5ce7]/20 blur-3xl pointer-events-none"></div>

        <div className="relative z-10 max-w-7xl w-full grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 border border-[#4a5fd4]/40 bg-[#4a5fd4]/10 px-4 py-2 rounded-full text-[#8fa3f8] text-sm mb-6 backdrop-blur-xl">
              <span className="w-2 h-2 bg-[#4a5fd4] rounded-full animate-pulse"></span>
              Next-Gen Web Solutions
            </div>

            <h1 className="text-5xl md:text-7xl font-black leading-tight tracking-tight">
              Web App
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Development
              </span>
              Services
            </h1>

            <p className="mt-8 text-[#9aa3c2] text-lg leading-8 max-w-2xl">
              SoftCoders builds fast, scalable, and secure web applications for
              startups, enterprises, and growing businesses. From SaaS platforms
              to custom portals, we craft web apps that deliver real results.
            </p>

            <div className="flex flex-wrap gap-5">

  {/* WHATSAPP CONSULTATION */}
  <a
    href="https://wa.me/919999999999?text=Hello%20SoftCoders%2C%20I%20want%20a%20free%20consultation."
    target="_blank"
    rel="noopener noreferrer"
    className="
      px-8
      py-4
      rounded-2xl
      bg-gradient-to-r
      from-[#2d3fb5]
      to-[#6b5ce7]
      font-semibold
      text-lg
      hover:scale-105
      transition
      duration-300
      shadow-2xl
      shadow-[#2d3fb5]/40
      inline-flex
      items-center
      justify-center
    "
  >
    Get Free Consultation
  </a>

  {/* INTERNAL PROJECT LINK */}
  <a
    href="/services/web-development"
    className="
      px-8
      py-4
      rounded-2xl
      border
      border-white/20
      hover:bg-white
      hover:text-black
      transition
      duration-300
      text-lg
      inline-flex
      items-center
      justify-center
    "
  >
    View Projects
  </a>

</div>

            <div className="grid grid-cols-3 gap-5 mt-14">
              {[
                ["150+", "Web Apps Built"],
                ["99%", "Uptime Guaranteed"],
                ["24/7", "Support"],
              ].map((item, index) => (
                <div
                  key={index}
                  className="p-5 rounded-3xl border border-[#4a5fd4]/25 bg-[#1a2472]/18 backdrop-blur-xl hover:translate-y-[-5px] transition duration-300"
                >
                  <h3 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#8fa3f8]">{item[0]}</h3>
                  <p className="text-[#9aa3c2] mt-2">{item[1]}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Hero Right — Browser Mockup Card */}
          <div className="relative flex items-center justify-center">
            <div className="absolute w-[500px] h-[500px] rounded-full bg-[#2d3fb5]/20 blur-3xl animate-pulse"></div>

            <div className="relative w-full max-w-lg bg-white/4 border border-[#4a5fd4]/25 rounded-[40px] p-8 backdrop-blur-2xl shadow-2xl shadow-[#2d3fb5]/20 hover:scale-[1.02] transition duration-500">
              {/* Browser chrome */}
              <div className="flex items-center gap-2 mb-6">
                <div className="w-3 h-3 rounded-full bg-red-500/70"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-400/70"></div>
                <div className="w-3 h-3 rounded-full bg-green-400/70"></div>
                <div className="flex-1 ml-4 bg-black/40 border border-[#4a5fd4]/20 rounded-lg px-4 py-1.5 text-xs text-[#9aa3c2]">
                  https://yourwebapp.com
                </div>
              </div>

              <div className="space-y-4">
                {/* Page speed */}
                <div className="p-4 rounded-2xl bg-black/30 border border-[#4a5fd4]/25">
                  <div className="flex justify-between mb-2 text-sm">
                    <span>Page Load Speed</span>
                    <span className="text-[#8fa3f8]">0.4s</span>
                  </div>
                  <div className="w-full h-2.5 rounded-full bg-white/10 overflow-hidden">
                    <div className="w-[95%] h-full bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7] rounded-full"></div>
                  </div>
                </div>

                {/* SEO Score */}
                <div className="p-4 rounded-2xl bg-black/30 border border-[#4a5fd4]/25">
                  <div className="flex justify-between mb-2 text-sm">
                    <span>SEO Score</span>
                    <span className="text-[#8fa3f8]">97/100</span>
                  </div>
                  <div className="w-full h-2.5 rounded-full bg-white/10 overflow-hidden">
                    <div className="w-[97%] h-full bg-gradient-to-r from-[#6b5ce7] to-[#8fa3f8] rounded-full"></div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="p-4 rounded-2xl bg-black/30 border border-[#4a5fd4]/25">
                    <h4 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#8fa3f8]">PWA</h4>
                    <p className="text-[#9aa3c2] mt-1 text-sm">Ready</p>
                  </div>
                  <div className="p-4 rounded-2xl bg-black/30 border border-[#4a5fd4]/25">
                    <h4 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#6b5ce7] to-[#8fa3f8]">SSL</h4>
                    <p className="text-[#9aa3c2] mt-1 text-sm">Secured</p>
                  </div>
                </div>

                <div className="p-5 rounded-2xl bg-gradient-to-r from-[#2d3fb5]/20 to-[#6b5ce7]/20 border border-[#4a5fd4]/20">
                  <p className="text-sm leading-7 text-[#c5cde8]">
                    SaaS platforms, admin dashboards, e-commerce portals,
                    booking systems, and real-time web applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-black">
              Our{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Web App
              </span>{" "}
              Services
            </h2>
            <p className="text-[#9aa3c2] max-w-3xl mx-auto mt-6 text-lg leading-8">
              End-to-end web application development with modern frameworks,
              clean architecture, and powerful integrations.
            </p>
          </div>

          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">
            {[
              {
                icon: "🌐",
                title: "SaaS Development",
                desc: "Multi-tenant SaaS platforms with subscription billing, dashboards, and scalable cloud infrastructure.",
              },
              {
                icon: "🛒",
                title: "E-Commerce Web Apps",
                desc: "High-converting online stores with payment gateways, inventory management, and order tracking.",
              },
              {
                icon: "📊",
                title: "Admin Dashboards",
                desc: "Data-rich admin panels with real-time analytics, charts, user management, and role-based access.",
              },
              {
                icon: "📅",
                title: "Booking & Scheduling",
                desc: "Online booking systems for clinics, salons, hotels, and service businesses with calendar integration.",
              },
              {
                icon: "🔗",
                title: "API & Integrations",
                desc: "RESTful and GraphQL APIs with third-party integrations — payment, CRM, ERP, and more.",
              },
              {
                icon: "⚡",
                title: "Progressive Web Apps",
                desc: "PWAs that work offline, load instantly, and deliver a native app experience in the browser.",
              },
            ].map((service, index) => (
              <div
                key={index}
                className="group relative p-8 rounded-[32px] bg-[#1a2472]/18 border border-[#4a5fd4]/25 hover:border-[#4a5fd4]/70 transition duration-500 overflow-hidden hover:-translate-y-3"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-[#2d3fb5]/0 to-[#6b5ce7]/0 group-hover:from-[#2d3fb5]/10 group-hover:to-[#6b5ce7]/10 transition duration-500"></div>
                <div className="relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7] mb-8 flex items-center justify-center text-2xl">
                    {service.icon}
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                  <p className="text-[#9aa3c2] leading-7">{service.desc}</p>
                  <button className="mt-8 text-[#8fa3f8] font-semibold group-hover:translate-x-2 transition duration-300">
                    Learn More →
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-28 px-6 lg:px-20 bg-white/[0.015] border-y border-[#4a5fd4]/25">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-black">
              Development{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Process
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: "Planning & Strategy", desc: "Requirement gathering, system architecture, and project roadmap aligned with your business goals." },
              { step: "UI/UX Design", desc: "Wireframes, prototypes, and pixel-perfect designs built for usability and conversion." },
              { step: "Development & Testing", desc: "Agile sprints with clean code, API integrations, and rigorous QA testing at every stage." },
              { step: "Launch & Scaling", desc: "Smooth deployment, performance tuning, monitoring, and ongoing support post-launch." },
            ].map((item, index) => (
              <div
                key={index}
                className="relative p-8 rounded-[30px] bg-black/30 border border-[#4a5fd4]/25 hover:border-[#4a5fd4]/50 transition duration-300 overflow-hidden"
              >
                <div className="absolute bottom-2 right-4 text-[100px] font-black text-white/5 leading-none select-none pointer-events-none z-0">
                  0{index + 1}
                </div>
                <h3 className="text-xl font-bold relative z-10">{item.step}</h3>
                <p className="text-[#9aa3c2] mt-5 leading-7 text-sm relative z-10">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why SoftCoders */}
      <section className="py-28 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-black leading-tight">
              Why Choose SoftCoders for
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Web App Development?
              </span>
            </h2>

            <p className="text-[#9aa3c2] mt-8 leading-8 text-lg">
              We don't just write code — we build digital products that perform.
              Our team of expert developers creates web applications optimized
              for speed, security, SEO, and business growth.
            </p>

            <p className="text-[#9aa3c2] mt-6 leading-8 text-lg">
              From single-page apps to large-scale enterprise platforms, every
              project is engineered with scalable architecture and clean,
              maintainable code that grows with your business.
            </p>

            <div className="space-y-4 mt-10">
              {[
                "Full-Stack Web Application Development",
                "React, Next.js & Node.js Experts",
                "REST & GraphQL API Development",
                "Cloud Hosting & DevOps Setup",
                "SEO-Optimized & Accessible Code",
                "Ongoing Maintenance & Support",
              ].map((point, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-5 rounded-2xl bg-[#1a2472]/18 border border-[#4a5fd4]/25"
                >
                  <div className="w-4 h-4 rounded-full bg-gradient-to-r from-[#2d3fb5] to-[#6b5ce7] flex-shrink-0"></div>
                  <span className="text-base">{point}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#2d3fb5]/20 to-[#6b5ce7]/20 blur-3xl"></div>
            <div className="relative rounded-[40px] border border-[#4a5fd4]/25 bg-[#1a2472]/18 p-10 backdrop-blur-xl">
              <h3 className="text-3xl font-black mb-10">Technology Stack</h3>
              <div className="grid grid-cols-2 gap-4">
                {[
                  "React.js",
                  "Next.js",
                  "Node.js",
                  "TypeScript",
                  "MongoDB",
                  "PostgreSQL",
                  "Tailwind CSS",
                  "AWS / Vercel",
                ].map((tech, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-2xl bg-black/35 border border-[#4a5fd4]/25 text-center hover:border-[#4a5fd4]/70 transition duration-300"
                  >
                    <span className="font-semibold">{tech}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-28 px-6 lg:px-20 bg-white/[0.015] border-y border-[#4a5fd4]/25">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-black">
              Industries We{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4a5fd4] to-[#6b5ce7]">
                Serve
              </span>
            </h2>
            <p className="text-[#9aa3c2] max-w-2xl mx-auto mt-6 text-lg leading-8">
              We build web applications for diverse industries with domain-specific expertise.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { icon: "🏥", label: "Healthcare" },
              { icon: "🎓", label: "Education" },
              { icon: "🏭", label: "Manufacturing" },
              { icon: "🛍️", label: "Retail & E-Commerce" },
              { icon: "🏦", label: "Finance & Fintech" },
              { icon: "🚚", label: "Logistics" },
              { icon: "🏨", label: "Hospitality" },
              { icon: "📱", label: "Startups & SaaS" },
            ].map((industry, index) => (
              <div
                key={index}
                className="p-6 rounded-[24px] bg-[#1a2472]/18 border border-[#4a5fd4]/25 hover:border-[#4a5fd4]/70 hover:-translate-y-2 transition duration-300 text-center"
              >
                <div className="text-4xl mb-4">{industry.icon}</div>
                <p className="font-semibold text-sm">{industry.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      

    </div>
  );
}